import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate, useParams } from "react-router-dom";

const QuizTest = () => {
    const { examId } = useParams();
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [questionLocation, setQuestionLocation] = useState(0);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [currentOptions, setCurrentOptions] = useState([]);
    const [summary, setSummary] = useState([]);
    const [questionStatus, setQuestionStatus] = useState([]);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [finalAlertModal, setFinalAlertModal] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('')
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            let data = { exam_id: examId, status: 0 };
            const token = localStorage.getItem("access_token");

            // Define custom headers
            const headers = {
                access_token: token, // Pass the token in the Authorization header
            };
            const result = await Apiservice.AllQuestionByExam(data, headers);

            if (result.success === true) {
                const retrievedData = result.data.map((q) => ({
                    ...q,
                    options: JSON.parse(q.options),
                }));
                setQuestions(retrievedData);
                setCurrentQuestion(retrievedData[0]);
                // Initialize question status state
                setQuestionStatus(new Array(retrievedData.length).fill({ isAnswer: 0 }));
                // Get current date and time
                const now = new Date();
                const formattedDateTime = now.toLocaleString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true, // Use 12-hour format
                });

                setStartTime(formattedDateTime);
                setLoading(false)
            } else {
                setLoading(false)
                console.error(result.message);
            }
        };
        fetchData();
    }, [examId]);

    useEffect(() => {
        if (questions.length > 0) {
            setCurrentQuestion(questions[questionLocation]);
            setCurrentOptions(currentQuestion.options);
        }
    }, [questionLocation, questions, currentQuestion]);

    const handleOptionChange = (event, questionIndex) => {
        const optionSelected = event.target.value;

        // Update the question status immutably
        setQuestionStatus((prevStatus) => {
            const updatedStatus = [...prevStatus];
            updatedStatus[questionIndex] = { isAnswer: 1 }; // Mark the current question as answered
            return updatedStatus;
        });

        // Update the summary
        setSummary((prev) => {
            const updatedSummary = prev.filter(
                (item) => item.question_id !== questions[questionLocation].id
            );

            const isCorrect = questions[questionLocation].options.some((opt) => {
                const optionKey = `option${optionSelected}`;
                return opt[optionKey] && opt.isCorrect;
            });

            const response = {
                question_id: questions[questionLocation].id,
                selected_option: optionSelected,
                isCorrect: isCorrect ? 1 : 0,
            };

            return [...updatedSummary, response];
        });
    };
    const handleClearChoice = () => {
        setSummary((prevSummary) =>
            prevSummary.filter(item => item.question_id !== questions[questionLocation].id)
        );

        setQuestionStatus((prevStatus) => {
            const updatedStatus = [...prevStatus];
            updatedStatus[questionLocation] = { isAnswer: 0 }; // Reset the question status
            return updatedStatus;
        });
    };

    const handleSubmit = async (examId) => {
        const now = new Date();
        const formattedDateTime = now.toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // Use 12-hour format
        });

        setEndTime(formattedDateTime);
        const data = {
            user_id: localStorage.getItem("user_id"),
            exam_id: examId,
            questionAttempt: summary.length,
            summary: summary,
            startTime: startTime,
            endTime: formattedDateTime,
            status: 0,
        };
        const token = localStorage.getItem("access_token");

        // Define custom headers
        const headers = {
            access_token: token, // Pass the token in the Authorization header
        };
        const result = await Apiservice.AddSummary(data, headers);
        console.log("add exam summary result", result)
        if (result.success === true) {
            // navigate(`/quiz/${examId}`);
            navigate(`/quizreview/${result.data}`)
        } else {
            console.error("Failed to submit summary:", result.message);
        }
    };

    const handleNext = () => {
        if (questionLocation < questions.length - 1) {
            // Move to the next question
            setQuestionLocation((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (questionLocation > 0) {
            setQuestionLocation((prev) => prev - 1);
        }
    };
    return (
        <>
            <div className="container-fluid" style={{ backgroundColor: 'ButtonFace', userSelect: 'none' }}>
                <div className="row mb-1">
                    {
                        loading ? (
                            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                                <div className="text-center">
                                    {/* Spinner with proper rotation */}
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                        style={{
                                            width: "2rem",
                                            height: "2rem",
                                            borderWidth: "3px",
                                        }}
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    {/* Minimalist Text */}
                                    <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                                </div>
                            </div>
                        )
                            :
                            (
                                <>
                                    <div className="col-12">
                                        <div className="row mb-1 p-1 m-1" style={{ backgroundColor: 'snow' }}>
                                            <div className="col text-center"><h5 className="h5">QUIZ</h5></div>
                                        </div>
                                        {questions.length > 0 ? (
                                            <>
                                                <div className="row mb-2 border border-2-black border-rounded radius-2 p-2 m-2" style={{ backgroundColor: 'snow' }}>
                                                    <div className="col">
                                                        <div className="d-flex flex-wrap gap-2">
                                                            {questions.map((q, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="position-relative border border-black"
                                                                    style={{
                                                                        width: '50px',
                                                                        height: '70px',
                                                                        borderRadius: '10px',
                                                                        backgroundColor: 'ButtonFace',
                                                                        overflow: 'hidden',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() => setQuestionLocation(index)}
                                                                >
                                                                    {/* Top Half */}
                                                                    <div
                                                                        className="w-100 h-50"
                                                                        style={{
                                                                            backgroundColor: index === questionLocation ? 'lightgreen' : 'aliceblue',
                                                                            borderBottom: '1px solid black',
                                                                        }}
                                                                    ></div>

                                                                    {/* Bottom Half */}
                                                                    <div
                                                                        className="w-100 h-50"
                                                                        style={{ backgroundColor: 'ButtonFace' }}
                                                                    ></div>

                                                                    {/* Corner Cutting Indicator */}
                                                                    {questionStatus[index]?.isAnswer === 0 && (
                                                                        <div
                                                                            className="position-absolute"
                                                                            style={{
                                                                                width: '0',
                                                                                height: '0',
                                                                                borderLeft: '20px solid transparent',
                                                                                borderTop: '20px solid red',
                                                                                top: '0',
                                                                                right: '0',
                                                                            }}
                                                                        ></div>
                                                                    )}

                                                                    {/* Question Number */}
                                                                    <div
                                                                        className="position-absolute w-100 text-center"
                                                                        style={{ bottom: '5px', fontSize: '12px' }}
                                                                    >
                                                                        {index + 1}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mb-2 border border-2-black p-2 m-2" style={{ backgroundColor: 'snow' }}>
                                                    <div className="col">
                                                        <div className="row mb-2 border">
                                                            <div className="row">
                                                                <div className="col-12 col-md">Question : {questionLocation + 1}</div>
                                                                {/* <div className="col-12 col-sm-3 col-md"> {questionLocation + 1} </div> */}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md col-12">
                                                                    <div className="row">
                                                                        <div className="col"><h6>Status - {questionStatus[questionLocation]?.isAnswer === 0 ? "Not yet Answered" : "Answered"}</h6></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col">
                                                                    <div className="row">
                                                                        <div className="col">Marked out of 1</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col">
                                                                <div className="row">
                                                                    <div className="col"><p>{currentQuestion.question}</p></div>
                                                                </div>
                                                                {console.log("test Current Options", currentOptions)}
                                                                {currentOptions.slice(0, currentOptions.length - 1).map((option, index) => (
                                                                    <div className="row" key={index}>
                                                                        <div className="col">
                                                                            <div className="row mb-1">
                                                                                <div className="col-md-1 col-2">
                                                                                    <input
                                                                                        type="radio"
                                                                                        className="btn-check"
                                                                                        name="options"
                                                                                        id={`option${index + 1}`}
                                                                                        value={index + 1}
                                                                                        checked={summary.some(
                                                                                            (item) =>
                                                                                                item.question_id === questions[questionLocation].id &&
                                                                                                item.selected_option === `${index + 1}`
                                                                                        )}
                                                                                        onClick={(e) => handleOptionChange(e, questionLocation)} // Pass the correct question index
                                                                                    />
                                                                                    <label
                                                                                        className="btn btn-outline-danger"
                                                                                        htmlFor={`option${index + 1}`}
                                                                                    >
                                                                                        {index === 0 ? "a" : index === 1 ? "b" : index === 2 ? "c" : "d"}
                                                                                    </label>
                                                                                </div>
                                                                                <div className="col-md-11 col">
                                                                                    {option[`option${index + 1}`]}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="row floart-start mb-2">
                                                            <div className="col">
                                                                <button className="btn btn-sm btn-outline-danger" onClick={handleClearChoice}>Clear My Choise</button>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col">
                                                                {questionLocation > 0 && (
                                                                    <button className="btn btn-sm btn-outline-danger float-start" onClick={handlePrevious}>
                                                                        Previous Question
                                                                    </button>
                                                                )}
                                                            </div>

                                                            <div className="col text-end">
                                                                {questionLocation < questions.length - 1 && (
                                                                    <button className="btn btn-sm btn-outline-primary float-end" onClick={handleNext}>
                                                                        Next Question
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col text-center">
                                                                {
                                                                    questionLocation === questions.length - 1 && (
                                                                        <button className="btn btn-primary btn-sm" onClick={() => setShowAlertModal(true)}>
                                                                            Submit
                                                                        </button>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="row mb-2 border border-2-black border-rounded radius-2 p-2 m-2" style={{backgroundColor:'snow'}}>
                                                <div className="col text-center">
                                                    <h5 className="h5">No questions are available</h5>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {showAlertModal && !finalAlertModal && (
                                        <>
                                            <div className="modal-backdrop fade show"></div> {/* Background fade effect */}
                                            <div className="modal fade show d-block" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{ opacity: finalAlertModal ? 0.5 : 1 }}>
                                                <div className="modal-dialog modal-dialog-centered"> {/* Centered modal with larger width */}
                                                    <div className="modal-content shadow-lg rounded-3">
                                                        <div className="modal-header bg-dark text-white">
                                                            <h5 className="modal-title" id="staticBackdropLabel">Test Summary</h5>
                                                            <button type="button" className="btn-close text-white" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowAlertModal(false)}></button>
                                                        </div>

                                                        {/* Scrollable Modal Body */}
                                                        <div className="modal-body p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                            {summary.length > 0 ? (
                                                                questions.length > 0 ? (
                                                                    <div className="table-responsive">
                                                                        <table className="table table-bordered table-striped table-hover">
                                                                            <thead className="table-dark text-center">
                                                                                <tr>
                                                                                    <th>Sl. No</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="text-center">
                                                                                {questions.map((question, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="fw-bold text-primary cursor-pointer" onClick={() => { setShowAlertModal(false); setQuestionLocation(index); }} onMouseEnter={(e) => e.target.style.cursor = 'pointer'}>{index + 1}</td>
                                                                                        <td className={questionStatus[index]?.isAnswer === 0 ? "text-danger" : "text-success"}>
                                                                                            {questionStatus[index]?.isAnswer === 0 ? "Not yet Answered" : "Answered"}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : (
                                                                    <div className="alert alert-warning text-center">
                                                                        <h6>No Questions Available</h6>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <div className="alert alert-danger text-center">
                                                                    <h6>Attend At Least One Question</h6>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Footer with Buttons */}
                                                        <div className="modal-footer bg-light">
                                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={() => setShowAlertModal(false)}>Back to Quiz</button>
                                                            <button type="button" className={`btn btn-primary btn-sm ${summary.length === 0 ? "disabled" : ""}`} onClick={() => setFinalAlertModal(true)}>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {finalAlertModal && (
                                        <>
                                            <div className="modal-backdrop fade show"></div> {/* Background fade effect */}
                                            <div className="modal fade show d-block" id="finalBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="finalBackdropLabel" aria-hidden="true" style={{ zIndex: 1051 }}>
                                                <div className="modal-dialog modal-dialog-centered modal-sm"> {/* Centered modal with larger width */}
                                                    <div className="modal-content shadow-lg rounded-3">
                                                        <div className="modal-header bg-dark text-white">
                                                            <button type="button" className="btn-close text-white" data-bs-dismiss="modal" aria-label="Close" onClick={() => setFinalAlertModal(false)}></button>
                                                        </div>

                                                        {/* Scrollable Modal Body */}
                                                        <div className="modal-body p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                            <h6>Submit the Results Anyway?</h6>
                                                        </div>

                                                        {/* Footer with Buttons */}
                                                        <div className="modal-footer bg-light">
                                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={() => setFinalAlertModal(false)}>Cancel</button>
                                                            <button type="button" className={`btn btn-primary btn-sm ${summary.length === 0 ? "disabled" : ""}`} onClick={() => handleSubmit(examId)}>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )
                    }



                </div >
            </div >
        </>
    );
};

export default QuizTest;
